













































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import FloatMenuAnimation from "@/resources/mixins/animations/floatMenuAnimation";
import { ClickOutsideDirective } from "@/helpers/directives/clickOutside.directive";
import { SpaceUserInterface } from "@/resources/interfaces/spaceUserInterfaces";
import Loader from "@/resources/mixins/loader/loader";
import { i18n } from "@/resources/locales";
import { GREEN, RED } from "@/resources/constants/busyReasons";
import space from "@/store/modules/space";
Component({
  name: "change-space-selector-component",
  directives: { ClickOutsideDirective },
});
export default class ChangeSpaceSelectorComponent extends mixins(
  FloatMenuAnimation,
  Loader,
  Vue
) {
  busy = "";
  get favouriteSpaces(): any {
    return this.$store.getters["SpaceStore/getFavouriteSpaces"];
  }
  get spaceUser(): SpaceUserInterface {
    return this.$store.getters["UserStore/getSpaceUser"];
  }
  close() {
    setTimeout(() => {
      this.closeChangeSpacenSelector();
    }, 50);
    setTimeout(() => {
      this.$store.dispatch(
        "FloatMenuStore/setOpenChangeSpaceSelectorAction",
        false
      );
    }, 200);
    const tooltip = document.getElementsByClassName("vs-tooltip");
    if (tooltip)
      while (tooltip.length > 0) {
        tooltip[0].parentNode.removeChild(tooltip[0]);
      }
  }
  async exitNubii() {
    this.startLoader(this.$store);
    const space = this.$store.getters["SpaceStore/getSpace"];
    await this.$store.dispatch("SpaceStore/setSpacesAvailablePageAction", 1);
    await this.$store.dispatch("SpaceStore/setLastPageSpacesAction", 2);
    await this.$store.dispatch("SpaceStore/getSpacePaginateAction", {
      id: space.superSpace.id,
      callback: (response) => {
        this.stopLoader(this.$store);
        this.$store.dispatch("SystemStore/setOpenChangeSpaceModalAction", true);
        this.close();
      },
      callbackError: (error) => {
        this.stopLoader(this.$store);
        this.close();
      },
    });
  }
  selectSpace(space): void {
    if (
      space.usersConnected != 0 &&
      space.usersConnected >= space.usersConnectedLimit
    ) {
      this.onWarning("", i18n.t("notifications.descriptions.spaceFull"));
      return;
    }
    localStorage.setItem("city", "OFF");
    localStorage.setItem("space_default", space.id.toString());
    window.location.reload();
  }
  getBusy(space): string {
    if (
      space.usersConnected == 0 ||
      space.usersConnected <= space.usersConnectedLimit / 2
    ) {
      this.busy = i18n.t("labels.free").toString();
      return GREEN.color;
    }
    if (
      space.usersConnected != 0 &&
      space.usersConnected >= space.usersConnectedLimit
    ) {
      this.busy = i18n.t("labels.full").toString();
      return RED.color;
    }
    if (
      space.usersConnected != 0 &&
      space.usersConnected > space.usersConnectedLimit / 2
    ) {
      this.busy = i18n.t("labels.almostFull").toString();
      return "orange";
    }
    return GREEN.color;
  }
  closeSpaceCase(space): number {
    if (space.spaceUser && space.spaceUser?.deletedAt) return 3;
    if (
      !space.spaceUser?.isAdmin &&
      !space.isSuperSpaceUserAdmin &&
      !space.enabled
    )
      return 1;
    if (!space.enabledBySuperAdmin) return 2;
    if (
      (space.spaceUser && !space.spaceUser.enabled) ||
      (space.isSuperSpaceUserEnabled !== null &&
        space.isSuperSpaceUserEnabled === false)
    )
      return 4;
    return 0;
  }
  closeSpaceCaseText(space) {
    switch (this.closeSpaceCase(space)) {
      case 1:
      case 2:
        return i18n.t("tooltips.disableSpace");
      case 3:
        return i18n.t("tooltips.deleteUser");
      case 4:
        return i18n.t("tooltips.disableUser");
      default:
        return "";
    }
  }
}
